import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { usersAPI } from '../../services/api';
import { parseApiError } from '../../utils/errors';

export default function EditUser() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: '', email: '', department: '', phone: '', is_active: true });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    usersAPI.get(id).then(({ data }) => {
      setForm({ full_name: data.full_name, email: data.email, department: data.department || '', phone: data.phone || '', is_active: data.is_active });
    }).finally(() => setLoading(false));
  }, [id]);

  const set = (k) => (e) => setForm((p) => ({ ...p, [k]: e.target.type === 'checkbox' ? e.target.checked : e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setError('');
    try {
      await usersAPI.update(id, form);
      navigate('/admin/users');
    } catch (err) {
      setError(parseApiError(err, 'Update failed'));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="page-loading">Loading...</div>;

  return (
    <div className="page">
      <div className="page-header">
        <h2>Edit User</h2>
        <button className="btn btn-ghost" onClick={() => navigate(-1)}>← Back</button>
      </div>
      <div className="form-card">
        {error && <div className="alert alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <h4 className="form-section-title">Personal Details</h4>
          <div className="form-row">
            <div className="form-group">
              <label>Full Name *</label>
              <input required value={form.full_name} onChange={set('full_name')} />
            </div>
            <div className="form-group">
              <label>Email *</label>
              <input type="email" required value={form.email} onChange={set('email')} />
            </div>
          </div>
          <div className="form-row">
            <div className="form-group">
              <label>Department</label>
              <input value={form.department} onChange={set('department')} />
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input value={form.phone} onChange={set('phone')} />
            </div>
          </div>
          <div className="form-group flex-row-center">
            <input type="checkbox" id="active" checked={form.is_active} onChange={set('is_active')} />
            <label htmlFor="active" style={{ marginLeft: 8 }}>Active Account</label>
          </div>
          <div className="form-actions">
            <button type="button" className="btn btn-ghost" onClick={() => navigate(-1)}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : 'Save Changes'}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
